import { Typography } from '@mui/material';
import React from 'react';
import { useAppSelector } from '../../store/reducers/store';
import { useTranslation } from 'react-i18next';

const UserName: React.FC = () => {
    const username = useAppSelector(state => state.authentication.nickname);
    const { t } = useTranslation()

    return <Typography variant='h2'>{t('DashboardWelcomBackText')}<br/>{username}</Typography>
}

export default UserName;